import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';

import { Guid, isEmptyString, isNil, isNotNil, Nillable } from '@web/utils';
import {
  DateComponent,
  DetailsViewComponent,
  NoDataComponent,
} from '@web/shared/ui';
import { WarehouseRestockStatus } from '../../enums/warehouse-restock-status';
import { WarehouseRestockType } from '../../enums/warehouse-restock-type';
import { WarehouseRestockStatusComponent } from '../warehouse-restock-status/warehouse-restock-status.component';
import { WarehouseRestockTypeComponent } from '../warehouse-restock-type/warehouse-restock-type.component';
import { OrderNumber } from '@web/shared/module/shop';
import { Tooltip } from 'primeng/tooltip';
import { WarehouseOrderEventBusService } from '../../bus/services/warehouse-order-event-bus.service';
import { WarehouseOrderPreviewBusEvent } from '../../bus/events/warehouse-order-preview-bus.event';

@Component({
  selector: 'app-warehouse-restock-details-attributes',
  imports: [
    DateComponent,
    DetailsViewComponent,
    NoDataComponent,
    WarehouseRestockStatusComponent,
    WarehouseRestockTypeComponent,
    Tooltip,
  ],
  templateUrl: './warehouse-restock-details-attributes.component.html',
  styleUrl: './warehouse-restock-details-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseRestockDetailsAttributesComponent {
  private readonly eventBus = inject(WarehouseOrderEventBusService);

  public readonly id = input.required<Guid>();
  public readonly restockedAt = input.required<Date>();
  public readonly createdAt = input.required<Date>();
  public readonly approvedAt = input<Nillable<Date>>();
  public readonly rejectedAt = input<Nillable<Date>>();
  public readonly number = input.required<string>();
  public readonly orderId = input.required<Nillable<Guid>>();
  public readonly orderNumber = input.required<Nillable<OrderNumber>>();
  public readonly status = input.required<WarehouseRestockStatus>();
  public readonly type = input.required<WarehouseRestockType>();
  public readonly comment = input<Nillable<string>>();
  public readonly personDignity = input<Nillable<string>>();
  public readonly personEmail = input<Nillable<string>>();
  public readonly personPhone = input<Nillable<string>>();
  public readonly shippingNumber = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;

  protected shouldShowPersonValue(value: Nillable<string>): value is string {
    return isNotNil(value) && !isEmptyString(value);
  }

  protected handleShowOrderDetailsClick(): void {
    const orderId = this.orderId();

    if (isNil(orderId)) {
      return;
    }

    this.eventBus.publish(new WarehouseOrderPreviewBusEvent({ orderId }));
  }
}
